export const ICON_BADGE_CLASSES =
  'flex size-9 shrink-0 items-center justify-center rounded-lg bg-muted';

/** Height cap applied to the tag when compact mode is enabled for small file tags. */
export const IMAGE_TAG_SMALL_THUMBNAIL_MAX_HEIGHT = 'max-h-14';
